<template>
  <b-card
    no-body
    class="card-statistics bg-gray pt-0 position-relative"
  >
    <div
      v-if="winner"
      class="winner-badge"
    >
      <b-avatar
        size="80"
        variant="warning"
      >
        <FeatherIcon
          size="30"
          icon="AwardIcon"
        />
      </b-avatar>
    </div>
    <b-card-header>
      <b-card-title>{{ manager.name }}</b-card-title>
      <b-card-text class="mr-25 mb-0 font-medium-4">
        {{ `Total ${manager.total} $` }}
      </b-card-text>
    </b-card-header>
    <b-card-body class="statistics-body">
      <b-row>
        <b-col
          v-for="item in statisticsItems"
          :key="item.icon"
          md="6"
          class="mb-2 mb-md-0 mt-1"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                :variant="item.color"
              >
                <feather-icon
                  size="24"
                  :icon="item.icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ item.title }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                {{ item.subtitle }}
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'

export default {
  name: 'ManagerCard',
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  props: {
    manager: {
      type: Object,
      default: () => {},
    },
    winner: {
      type: Boolean,
      default: false,
    },
    isTotal: {
      type: Boolean,
      default: false,
    },
    query: {
      type: Object,
      default: () => {},
    },

  },
  data() {
    return {
      statisticsItems: [],
    }
  },
  watch: {
    manager() {
      this.setStatistics()
    },
  },
  mounted() {
    this.setStatistics()
  },
  methods: {
    setStatistics() {
      this.statisticsItems = [
        {
          icon: 'DollarSignIcon',
          color: 'light-primary',
          title: `${this.manager.paid}$`,
          subtitle: 'Paid',
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'CreditCardIcon',
          color: 'light-danger',
          title: `${this.manager.unpaid}$`,
          subtitle: 'UnPaid',
          customClass: 'mb-2 mb-xl-0',
        },
      ]
    },
  },
}
</script>
<style>
.card-statistics .statistics-body {
  padding: 0 2.4rem 2.8rem !important;
}
.winner-badge{
  position: absolute;
  left: 47%;
  top:-40px
}
</style>
